import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/system-tools' },
  { label: '文章', path: '/article/getting-started' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-bold text-primary-500">
              91<span className="text-foreground-800">免费版</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : scrolled
                      ? 'text-foreground-700'
                      : 'text-foreground-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="inline-flex items-center px-5 py-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              免费下载
            </a>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`ri-${
                mobileOpen ? 'close' : 'menu'
              }-line text-xl ${scrolled ? 'text-foreground-800' : 'text-white'}`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="inline-flex items-center justify-center px-5 py-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              免费下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}